exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sessionDropDownItem {\n  color: #4b8bb1;\n}\n.iconCss::before {\n  font-size: 28px !important;\n  line-height: 20px;\n}\n.iconHeightWidth {\n  height: 24px !important;\n  width: 24px !important;\n}\n.sessionMenuIcon {\n  width: 2em !important;\n  height: 2em !important;\n  background-size: 2em 2em;\n}\n.borderNone {\n  border: none !important;\n}\n.borderBottomWithGray {\n  border-bottom: 1px solid #ccc!important;\n  border-radius: 0px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/sessionMenu.less
// module id = 3130
// module chunks = 0